import React from 'react';

function ProductCard({ product, onAddToCart, onClick, inCart }) {
  const stars = Array.from({ length: 5 }, (_, i) => i < Math.round(product.rating));

  return (
    <div className="ecom-card" onClick={onClick}>
      <div className="ecom-card-image" style={{ background: product.color + '15' }}>
        <span className="ecom-card-emoji">{product.image}</span>
        {product.badge && (
          <span className={`ecom-card-badge ${product.badge.toLowerCase().replace(' ', '-')}`}>
            {product.badge}
          </span>
        )}
      </div>
      <div className="ecom-card-body">
        <span className="ecom-card-category">{product.category}</span>
        <h3 className="ecom-card-name">{product.name}</h3>
        <div className="ecom-card-rating">
          <div className="ecom-stars">
            {stars.map((filled, i) => (
              <span key={i} className={`ecom-star ${filled ? 'filled' : ''}`}>★</span>
            ))}
          </div>
          <span className="ecom-review-count">({product.reviews})</span>
        </div>
        <div className="ecom-card-footer">
          <div className="ecom-card-price">
            <span className="ecom-price">${product.price.toFixed(2)}</span>
            {product.originalPrice && (
              <span className="ecom-original-price">${product.originalPrice.toFixed(2)}</span>
            )}
          </div>
          <button
            className={`ecom-add-btn ${inCart ? 'in-cart' : ''}`}
            onClick={(e) => { e.stopPropagation(); onAddToCart(); }}
          >
            {inCart ? '✓ In Cart' : '+ Add'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
